
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/membership/join/payment/confirmation",
      function () {
        return require("private-next-pages/community/membership/join/payment/confirmation.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/membership/join/payment/confirmation"])
      });
    }
  